import styled from "@emotion/styled";
export const StyledAsymmetricSideBySideTextAndAssetComponent = styled.div`
  .asymmetric-side-by-side-text-and-asset-content.side-by-side-content {
    padding-bottom: 64px;
  }
`;
